import Home from './home';
import Welcome from './welcome';

export { Welcome };
export default Home;
